module.exports = __webpack_public_path__ + "static/media/loading7.86946268.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading7.png
// module id = 192
// module chunks = 0